import { getAppConfig } from '@/api/common'
import useStore from '@/store'

export const CHILD_PREFIX = 'auth'

export const MICRO_APPS = [
  {
    name: 'authCommon',
    url: ''
  },
]

export const MICRO_APPS_URL = async () => {
  const { setState, getState } = useStore
  const { auth } = getState() as any
  if (auth) {
    return { auth }
  } else {
    const res: any = await getAppConfig({ configValue: 'url' })
    const auth = res.find((v: { domain: string }) => v.domain === 'auth') || {}
    const neo = { auth: auth.configValue }
    setState(neo)
    return neo
  }
}

export const BASE_ROUTE = {
  login: '/login',
  userList: '/user',
  roleList: '/role',
  agreement: '/agreement',
  privacyPolicy: '/privacyPolicy',
}

export default {}
